export default __webpack_public_path__ + "static/media/visa-and-mastercard-logos.78c0e0f2.png";